import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/zoning')({
  component: AdminZoningRoute,
});

function AdminZoningRoute() {
  return <Outlet />;
}
